<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('forms.inputs.client')">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="clientParams.name"
                  value="clientParams.name"
                  :label="$t('forms.inputs.name')"
                >
                </va-input>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="clientParams.trading_name"
                  value="clientParams.trading_name"
                  :label="$t('forms.inputs.tradingName')"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="clientParams.address"
                  value="clientParams.address"
                  :label="$t('forms.inputs.address')"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="clientParams.district"
                  value="clientParams.district"
                  :label="$t('forms.inputs.district')"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="clientParams.city"
                  value="clientParams.city"
                  :label="$t('forms.inputs.city')"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="clientParams.state"
                  value="clientParams.state"
                  :label="$t('forms.inputs.state')"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="clientParams.zip_code"
                  value="clientParams.zip_code"
                  :label="$t('forms.inputs.zipCode')"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="clientParams.latitude"
                  value="clientParams.latitude"
                  :label="$t('forms.inputs.latitude')"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="clientParams.longitude"
                  value="clientParams.longitude"
                  :label="$t('forms.inputs.longitude')"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="clientParams.start_of_service"
                  value="clientParams.start_of_service"
                  v-mask="maskTime"
                  :label="$t('forms.inputs.startService')"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="clientParams.end_of_service"
                  value="clientParams.end_of_service"
                  v-mask="maskTime"
                  :label="$t('forms.inputs.endService')"
                />
              </div>
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="clientParams.cpf_cnpj"
                  value="clientParams.cpf_cnpj"
                  label="CPF ou CNPJ"
                />
              </div>

            </div>

          <div class="row">
            <div class="flex md2 sm6 xs12">
              <va-button
                v-if="clientParams.clientId == ''"
                medium
                inline
                color="secondary"
                icon="fa fa-save"
                class="ma-0"
                @click="create(clientParams)"
              >
                {{ $t('menu.save') }}
              </va-button>
              <va-button
                v-else
                medium
                inline
                color="secondary"
                icon="fa fa-save"
                class="ma-0"
                @click="update(clientParams)"
              >
                {{ $t('menu.update') }}
              </va-button>
            </div>
            <div class="flex md2 sm6 xs12">
              <va-button
                medium
                inline
                color="#ff842b"
                icon="fa fa-chevron-left"
                class="ma-0"
                  :to="{ name: 'clients', params: {
                    current_page: this.$route.params.current_page, 
                    searchName: this.$route.params.searchName, 
                    perPage: this.$route.params.perPage }
                    }"
              >
                {{ $t('menu.back') }}
              </va-button>
            </div>
          </div>

          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>

import ClientAPI from '@/services/ClientAPI'
import { showError } from '@/global'

export default {
  name: 'form-clients',
  components: {},
  data () {
    return {
      clientParams: {
        clientId: '',
        name: '',
        trading_name: '',
        address: '',
        district: '',
        city: '',
        state: '',
        zip_code: '',
        latitude: '',
        longitude: '',
        start_of_service: '',
        end_of_service: '',
        cpf_cnpj: ''
      },
      maskTime: '##:##',
    }
  },
  mounted () {
    if (this.$route.params.id != undefined) {
      ClientAPI.getClientById(this.$route.params.id).then(response => {
        this.clientParams = response.data.client
      })
    }
  },
  computed: {
  },
  methods: {
    create (clientParams) {
      ClientAPI.createClient(clientParams).then(response => {
        this.client = response.data;

          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          }),
          
        this.$router.push('/admin/tables/clients')
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
    update (clientParams) {
      ClientAPI.updateClient(clientParams).then(response => {
        self.data = response.data;

          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          }),
          
        this.$router.push('/admin/tables/clients')
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    }
  }
}
</script>

<style>
  .row.row-inside {
    max-width: none;
  }
</style>
